export default __webpack_public_path__ + "static/button-video-play@3x-1b8dc3b0ab36093e2de66fbab767ca24.png";